import moment from 'moment-timezone';
import config from '../../../../config';
var momentFromTimeParts = function (timeParts) {
    return moment("".concat(timeParts.hour, ":").concat(timeParts.minute, " ").concat(timeParts.partOfDay), config.timeFormat);
};
var getNextRoundedMoment = function (value, roundToMins) {
    var valueInMs = moment(value).startOf('minute').valueOf();
    var intervalInMs = roundToMins * 60 * 1000;
    var roundedTime = Math.ceil(valueInMs / intervalInMs) * intervalInMs;
    return moment(roundedTime);
};
var getTimePartsFromMoment = function (timeMoment) { return ({
    hour: Number(timeMoment.format('h')),
    minute: timeMoment.minute(),
    partOfDay: timeMoment.format('a'),
}); };
export var getTimePartsFromValue = function (value, valueFormat) {
    var timeMoment = moment(value, valueFormat);
    return getTimePartsFromMoment(timeMoment);
};
export var getValueFromTimeParts = function (timeParts, valueFormat) {
    return momentFromTimeParts(timeParts).format(valueFormat);
};
export var getNextRoundedTimeParts = function (value, valueFormat, roundToMins) {
    var valueMoment = moment(value, valueFormat);
    var nextRoundedMoment = getNextRoundedMoment(valueMoment, roundToMins);
    return getTimePartsFromMoment(nextRoundedMoment);
};
export var TWELVE_HOURS_OPTIONS = Array.from({ length: 12 }, function (_, index) { return index + 1; });
export var generateMinuteOptions = function (bookingIntervalMins) {
    var options = [];
    for (var i = 0; i < 60; i += bookingIntervalMins) {
        options.push(i);
    }
    return options;
};
export var combineDateAndTime = function (date, time, timezone, format) {
    var dateFormat = format === 'MM/DD/YYYY' ? 'MM-DD-YYYY' : 'DD-MM-YYYY';
    var zonedMomentDate = moment.tz(date, dateFormat, timezone);
    var momentTime = moment(time, 'HH:mm');
    var zonedCombinedMoment = zonedMomentDate
        .clone()
        .hour(momentTime.hour())
        .minute(momentTime.minute())
        .second(0)
        .millisecond(0);
    return zonedCombinedMoment.toJSON();
};
export var getScheduledDateTime = function (utcDateTime, timezone, dateFormat, time24HourFormat) {
    if (time24HourFormat === void 0) { time24HourFormat = false; }
    if (!utcDateTime) {
        var now = moment();
        return {
            scheduledDate: now.format(dateFormat),
            scheduledTime: now.format(time24HourFormat ? 'HH:mm' : 'hh:mm A'),
        };
    }
    var utcMomentDateTime = moment.utc(utcDateTime);
    if (!utcMomentDateTime.isValid()) {
        utcMomentDateTime = moment.utc(utcDateTime);
    }
    var scheduledDate = utcMomentDateTime.tz(timezone).format(dateFormat);
    var scheduledTime = utcMomentDateTime.tz(timezone).format(time24HourFormat ? 'HH:mm' : 'hh:mm A');
    return {
        scheduledDate: scheduledDate,
        scheduledTime: scheduledTime,
    };
};
export var convert24to12Hour = function (time24hr) {
    var momentObj = moment(time24hr, 'HH:mm');
    if (!momentObj.isValid()) {
        return null;
    }
    var time12hr = momentObj.format('h:mm A');
    return time12hr;
};
